// Search dropdown entries (value sent as search_column -> label) and search box placeholder for the
// Product Info, Item Info and Family Info lists. The values must stay in step with the whitelists in
// the API's App\Libraries\ListSearch\ListSearchSql.

export const SEARCH_ALL = 'all';

export const PRODUCT_INFO_SEARCH_KEYS = {
  [SEARCH_ALL]: 'All (Description, Code, ID)',
  prod_info_desc: 'Description',
  prod_info_pr_code: 'Code',
  prod_info_id: 'ID',
  prod_info_category_desc: 'Category',
  prod_info_ordering: 'Ordering',
  prod_info_from_date: 'From Date',
  prod_info_upto_date: 'Upto Date',
  prod_info_active_yn: 'Active ?',
};

export const ITEM_INFO_SEARCH_KEYS = {
  [SEARCH_ALL]: 'All (Description, Item Id, Code, ID)',
  sii_desc: 'Description',
  sii_item_id: 'Item Id',
  sii_code: 'Code',
  sii_sys_id: 'ID',
  sii_if_desc: 'Family desc',
  sii_ordering: 'Ordering',
  sii_active_yn: 'Active ?',
  item_info_image_path: 'Image',
  sii_br_desc: 'Brand Desc',
  sii_collection_desc: 'collection',
  sii_br_code: 'Brand Code',
};

// The family table has no separate sys id, its code is the key.
export const FAMILY_INFO_SEARCH_KEYS = {
  [SEARCH_ALL]: 'All (Description, Code)',
  SFI_DESC: 'Family Description',
  SFI_CODE: 'Family Code',
  SFI_STATUS: 'Family Status',
  SFI_BR_DESC: 'Brand Desc',
  SFI_COLLECTION_DESC: 'Collection Desc',
  SFI_CUSTOMIZABLE_YN: 'Customizable YN?',
  SFI_APPLICABLE_COUNTRIES: 'Applicable Countries',
  SFI_ACTIVE_YN: 'Active YN?',
  SFI_ORDERING: 'Ordering',
};

// "Search by Description, Code or ID" built from the label of the "all" entry, so the placeholder
// always says what the default search covers.
export const searchPlaceholder = (searchKeys) => {
  const label = (searchKeys && searchKeys[SEARCH_ALL]) || '';
  const match = label.match(/\(([^)]*)\)/);
  if (!match) return 'Search';
  const parts = match[1].split(',').map((p) => p.trim()).filter(Boolean);
  if (parts.length < 2) return `Search by ${parts[0] || ''}`.trim();
  return `Search by ${parts.slice(0, -1).join(', ')} or ${parts[parts.length - 1]}`;
};
